import React, {useEffect, useImperativeHandle} from "react";
import {Col, Form, Input, Row, Select, TreeSelect} from "antd";
import {useModel} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";


export default function ({formRef, actionType}) {
    const [
        {invoiceTypeDict, saleOrderTypeDict, salePriceTypeDict, customerTypeDict},
        {getInvoiceTypeDict, getSaleOrderTypeDict, getSalePriceTypeDict, getSaleOrderStatusDict, getCustomerTypeDict}] = useModel("cmDict");

    useEffect(() => {
        getInvoiceTypeDict();
        getSaleOrderTypeDict();
        getSalePriceTypeDict();
        getSaleOrderStatusDict();
        getCustomerTypeDict();
    }, []);

    const [form] = Form.useForm();
    const [{selectedDocument}, {insert, update}] = useModel("purchaseOrder");

    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedDocument) {
                form.setFieldsValue(selectedDocument)
            }
        }
    }, [actionType, selectedDocument])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        insert: () => {
            // console.log(form.getFieldsValue());
            form.validateFields().then(data => {
                insert({data});
            })
        },
        update: () => {
            // console.log(form.getFieldsValue());
            form.validateFields().then(data => {
                update({data});
            })
        },
        reset: () => {
            form.resetFields();
        },
    }));

    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
        >

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="saleOrderCode"
                        label="销售订单号"
                    >
                        <Input placeholder="销售订单号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerName"
                        label="客户名称"
                    >
                        <Input placeholder="客户名称"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="whOperator"
                        label="库管"
                    >
                        <Input placeholder="库管"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="orderType"
                        label="订单类型"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="订单类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={saleOrderTypeDict}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="consignee"
                        label="联系人"
                    >
                        <Input placeholder="联系人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="salesMan"
                        label="业务员"
                    >
                        <Input placeholder="业务员"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="invoiceType"
                        label="发票类型"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="发票类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={invoiceTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="contactPhone"
                        label="手机号"
                    >
                        <Input placeholder="手机号"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="orgId"
                        label="公司"
                    >
                        <Input placeholder="公司"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="priceType"
                        label="售价选择"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="售价选择"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={salePriceTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerType"
                        label="客户类型"
                    >
                        <TreeSelect
                            showSearch
                            allowClear
                            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                            placeholder="客户类型"
                            treeDefaultExpandAll
                            onChange={() => {
                            }}
                            treeData={customerTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="detailedAddress"
                        label="收货地址"
                    >
                        <Input placeholder="收货地址"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="discount"
                        label="整单折扣"
                    >
                        <Input placeholder="整单折扣" suffix="%"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="wholeOrderDiscount"
                        label="整单优惠"
                    >
                        <Input placeholder="联系电话"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="discountPrice"
                        label="优惠总金额"
                    >
                        <Input placeholder="优惠总金额"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="aggregateAmount"
                        label="总金额"
                    >
                        <Input placeholder="总金额"/>
                    </Form.Item>
                </Col>

            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="saleOrderDesc"
                        label="备注"
                        labelCol={{span: 3}}
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
                </Col>
            </Row>

        </Form>
    )
}